import React, { FC } from "react";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import styles from "./UnblockUserModal.module.scss";

interface UnblockUserModalProps {
  onClose: () => void;
  onSubmit?: (userId: any[]) => void;
  isSubmitting?: boolean;
  userId: any;
}

const UnblockUserModal: FC<UnblockUserModalProps> = ({
  onClose,
  onSubmit,
  isSubmitting,
  userId,
}) => {
  const handleConfirm = () => {
    onSubmit?.([userId]);
  };

  return (
    <div className="create-promotion-modal">
      <Backdrop open={true}>
        <div className={styles["modalContainer"]}>
          <h4 className={styles["modalContainer__title"]}>Unblock User</h4>

          <div className={styles["modalContainer__inputWrapper"]}>
            Are you sure you want to unblock this user?
          </div>

          <div className={styles["modalContainer__buttonGroup"]}>
            <Button
              onClick={onClose}
              className={`${styles["modalContainer__buttonGroup__cancelButton"]} create-promo-cancel-button`}
              variant="outlined"
              disabled={isSubmitting}
            >
              Cancel
            </Button>

            <Button
              onClick={handleConfirm}
              className={`${styles["modalContainer__buttonGroup__submitButton"]} create-promo-submit-button`}
              variant="contained"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Unblock"
              )}
            </Button>
          </div>
        </div>
      </Backdrop>
    </div>
  );
};

export default UnblockUserModal;
